const t = "_wrapper_ghynp_1", n = "_title_ghynp_12", s = "_links_ghynp_15", _ = "_listItem_ghynp_24", l = "_link_ghynp_15", e = {
  wrapper: t,
  title: n,
  links: s,
  listItem: _,
  link: l
};
export {
  e as default,
  l as link,
  s as links,
  _ as listItem,
  n as title,
  t as wrapper
};
